import { apiRequest } from "./apiClient";
import { stateChangingRequest } from "./authApi";

export function getFieldCases() {
  return apiRequest("/api/field-cases");
}

export function createFieldCase(fieldCase) {
  return stateChangingRequest("/api/field-cases", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(fieldCase),
  });
}

export function updateFieldCase(fieldCaseId, fieldCase) {
  return stateChangingRequest(
    `/api/field-cases/${encodeURIComponent(fieldCaseId)}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(fieldCase),
    },
  );
}

export function updateFieldCaseVisibility(fieldCaseId, visibility) {
  return stateChangingRequest(
    `/api/field-cases/${encodeURIComponent(fieldCaseId)}/visibility`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ visibility }),
    },
  );
}

export function uploadFieldCaseImage(fieldCaseId, image) {
  const formData = new FormData();
  formData.append("image", image, image.name);
  return stateChangingRequest(
    `/api/field-cases/${encodeURIComponent(fieldCaseId)}/images`,
    { method: "POST", body: formData },
  );
}

export function deleteFieldCaseImage(fieldCaseId, imageId) {
  return stateChangingRequest(
    `/api/field-cases/${encodeURIComponent(
      fieldCaseId,
    )}/images/${encodeURIComponent(imageId)}`,
    { method: "DELETE" },
  );
}

export function reorderFieldCaseImages(fieldCaseId, imageIds) {
  return stateChangingRequest(
    `/api/field-cases/${encodeURIComponent(fieldCaseId)}/images/order`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ imageIds }),
    },
  );
}

export function importFieldCases(fieldCases) {
  return stateChangingRequest("/api/field-cases/import", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fieldCases }),
  });
}

export function deleteFieldCase(fieldCaseId) {
  return stateChangingRequest(
    `/api/field-cases/${encodeURIComponent(fieldCaseId)}`,
    { method: "DELETE" },
  );
}
